import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/options-saas/app/(marketing)/options-flows-mcp/client.tsx");
